// extracted by mini-css-extract-plugin
export default {"section":"modal-footer_section__VL5R+","section_without_shadow":"modal-footer_section_without_shadow__YFL2g","with_border_top":"modal-footer_with_border_top__NUfqV"};